import * as React from 'react';
import { SectionPanel } from 'ui/section-panel/section-panel';
import { MainGridContainer } from 'ui/common/main-grid-container/main-grid-container';
import { CodetableItemFormComponentProps } from 'app/area/codetable/item/codetable-item-form';
import { CodeUserGroups, CodeCaseTypes } from 'app/area/codetable/item/code-pickers';
import { CodeExclude } from 'app/area/codetable/item/code-fields';
import { shouldRenderVisibility } from 'app/area/codetable/item/codetable-item-form-render-helpers';
import { ReadOnlyType, SlotProps } from 'app/area/codetable/item/types';
import { renderSlot } from 'app/area/codetable/item/screen-renderer/render-slot';

export const Visibility = (props: Partial<CodetableItemFormComponentProps> & SlotProps) => {

  const { translation, locale, metadata, codeItem, loadOptions, options, codetableId,
    originalCodeItem, readOnlyConfig, updateUserGroups, updateCaseTypes, sectionSlots,
    updateExcludedFields, sectionRef, validation
  } = props;

  const readOnly = readOnlyConfig && readOnlyConfig[ReadOnlyType.all];

  return shouldRenderVisibility(metadata)
    ? <div ref={sectionRef}>
      <SectionPanel
        className="admin-paper-top-panel"
        componentId="visibility"
        validation={undefined}
        info={{ text: translation.visibility }}
        label={{ visible: true, text: translation.visibility }} />
      <MainGridContainer>
        <div className="row">
          {renderSlot(sectionSlots, 'top', props)}
          <CodeUserGroups
            readOnly={readOnlyConfig && readOnlyConfig[ReadOnlyType.subsets]}
            metadata={metadata}
            codetableId={codetableId}
            codeItem={codeItem}
            options={options}
            displaySelectAll={true}
            validation={validation}
            loadOptions={loadOptions}
            onChange={updateUserGroups}
            translation={translation}
            locale={locale} />
          <CodeCaseTypes
            readOnly={readOnly}
            metadata={metadata}
            codeItem={codeItem}
            options={options}
            displaySelectAll={true}
            validation={validation}
            loadOptions={loadOptions}
            onChange={updateCaseTypes}
            translation={translation}
            locale={locale} />
          <CodeExclude
            readOnly={readOnly}
            codetableId={codetableId}
            metadata={metadata}
            codeItem={codeItem}
            validation={validation}
            originalCodeItem={originalCodeItem}
            options={options}
            loadOptions={loadOptions}
            onChange={updateExcludedFields}
            translation={translation} />
          {renderSlot(sectionSlots, 'bottom', props)}
        </div>
      </MainGridContainer>
    </div>
    : null;
};
